module.exports = __webpack_public_path__ + "static/media/icon-caret-next.110fecd7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-caret-next.svg
// module id = 1235
// module chunks = 19